const getBaseURL = () => {
  const hostname = window.location.hostname;

  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:3000';
  }

  // UAT/Staging environment
  if (hostname.includes('uat') || hostname.includes('staging')) {
    return 'https://uat.api.autopulsecrm.com';
  }

  // Production (default fallback)
  return 'https://api.autopulsecrm.com';
};

const Config = {
  baseURL: getBaseURL(),
  ringCentralBase: 'https://api.rc.autopulsecrm.com',
  ringCentralHealth: 'https://api.rc.autopulsecrm.com/health',
  ringCentralAllStatus: 'https://api.rc.autopulsecrm.com/api/users/call-status/all',
  ringCentralDebug: 'https://api.rc.autopulsecrm.com/api/debug/users',
  ringCentralWebSocket: 'wss://api.rc.autopulsecrm.com/ws/presence',
};

export default Config;
